// books/fd.js -- FanDuel per-book SlipSync config at lifecycle stage 'capture' (ADR 006, #885).
// Single job: supply FanDuel's WebView parameters, capture spec and copy to the shared
// framework. Nothing is imported at this stage; the FanDuel import adapter is a later spec.
// FD_CAPTURE_SPEC mirrors api/lib/slipsync/book-registry.js CAPTURE_SPECS.fan as a literal
// copy (app code must not import api/ -- plan G5); slipsync-capture-parity.test.js pins them.
// Paths, query grammars and XHR transport: docs/research/2026-10-08-fanduel-mybets-payload.md
// rows 1, 2, 4d, 8.
import { buildCaptureScript } from '../response-intercept';

const FD_RESULT = '(?:WON|LOST|VOID|CASHED_OUT|PLACED|SETTLED|VOID_WITH_TOKEN|SAVED|UNAVAILABLE)';

export const FD_CAPTURE_SPEC = {
  hosts: ['api.sportsbook.fanduel.com'],
  pathPattern: '^/(my-bets/(v2/)?search-bets|sbapi/fetch-my-bets)$',
  // Kept query key -> the grammar its decoded value must match in full; anything else is ':redacted'.
  keptQuery: {
    isSettled: '^(?:true|false)$',
    isLive: '^(?:true|false)$',
    fromRecord: '^\\d{1,6}$',
    toRecord: '^\\d{1,6}$',
    sortDir: '^(?:ASC|DESC)$',
    sortParam: '^(?:SETTLEMENT_DATE|PLACEMENT_DATE|CLOSEST_START_TIME)$',
    result: `^${FD_RESULT}(?:,${FD_RESULT}){0,8}$`,
    eventTypeIds: '^(?=(?:\\D*\\d){1,8}\\D*$)\\d{1,6}(?:,\\d{1,6}){0,7}$',
    product: '^SB$',
  },
  keptHeader: 'x-sportsbook-region',
  // The intercept installs only on this domain or its subdomains (pre-Codex Sec-1).
  pageHostSuffix: 'fanduel.com',
  maxBodyChars: 200000,
};

export const fdConfig = {
  key: 'fan',
  displayName: 'FanDuel',
  stage: 'capture',
  needsRegionSelection: false,
  validRegions: null,
  // Verified 2026-10-08: returns 200 (and nj. does too); FanDuel routes to the user's state.
  getWebViewUrl: () => 'https://sportsbook.fanduel.com/my-bets',
  captureSpec: FD_CAPTURE_SPEC,
  getCaptureScript: (nonce) => buildCaptureScript(FD_CAPTURE_SPEC, nonce),
  webViewTitle: 'FanDuel',
  captureCopy: 'FanDuel sync is coming. Open My Bets (Open and Settled), then close. Nothing is imported yet.',
  errorMessages: {
    noBetsFound: "We didn't see your FanDuel bets. Open My Bets, then close.",
    captureNotSaved: "Couldn't save your FanDuel capture. Try again.",
    apiError: 'Something went wrong reading FanDuel. Try again.',
    openFailed: 'Unable to open FanDuel. Try again.',
    submitTimeout: "Couldn't confirm your FanDuel capture was saved. Try again.",
  },
};
